module.exports = __webpack_public_path__ + "static/media/powered-by-g0v.52211dab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/powered-by-g0v.svg
// module id = 2195
// module chunks = 1